import { useCallback, useEffect, useRef, useState } from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

export const AdminConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);
  const dialogRef = useRef(null);
  useEffect(() => {
    const open = ({ detail }) => {
      dialogRef.current?.resolve(false);
      dialogRef.current = detail;
      setDialog(detail);
    };
    window.addEventListener('admin:confirm', open);
    return () => {
      window.removeEventListener('admin:confirm', open);
      dialogRef.current?.resolve(false);
    };
  }, []);
  const finish = useCallback((answer) => {
    dialogRef.current?.resolve(answer);
    dialogRef.current = null;
    setDialog(null);
  }, []);
  useEffect(() => {
    if (!dialog) return undefined;
    const key = (event) => {
      if (event.key === 'Escape') finish(false);
    };
    document.addEventListener('keydown', key);
    return () => document.removeEventListener('keydown', key);
  }, [dialog, finish]);
  return <>{children}{dialog && <div className="fixed inset-0 z-[120] bg-black/50 flex items-center justify-center p-4" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && finish(false)}><section role="alertdialog" aria-modal="true" aria-labelledby="admin-confirm-title" className="bg-white rounded-xl shadow-2xl w-full max-w-md p-5"><div className="flex justify-between gap-3"><span className="w-10 h-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center"><FiAlertTriangle /></span><button onClick={() => finish(false)} aria-label="Close confirmation"><FiX /></button></div><h2 id="admin-confirm-title" className="font-bold text-lg mt-3">{dialog.options.title || 'Please confirm'}</h2><p className="text-sm text-black mt-2">{dialog.message}</p><div className="flex justify-end gap-3 mt-6"><button onClick={() => finish(false)} className="border px-4 py-2 rounded-lg">Cancel</button><button autoFocus onClick={() => finish(true)} className="bg-red-600 text-white px-4 py-2 rounded-lg">{dialog.options.confirmLabel || 'Confirm'}</button></div></section></div>}</>;
};
